import { graphql } from "../gql";

export default graphql(`
  query GetGolfEvents {
    getGolfEvents {
      id
      name
    }
  }
`);
